import { camelizeResponseData } from 'src/utilities/http-data-casing';
import { OrderRestrictionsResponseUI } from 'src/types/OrderRestrictions';
import { sdk } from 'src/utilities/sdk';

export const orderRestrictionsUrl =
  '/targetedaudiencesgateway/order-restrictions/config';

export async function getOrderRestrictions(): Promise<OrderRestrictionsResponseUI> {
  try {
    const data = await sdk.http.get(orderRestrictionsUrl);
    return camelizeResponseData(data) as OrderRestrictionsResponseUI;
  } catch (error) {
    return Promise.reject(error);
  }
}
